export default {
  noSignalsSelected: 'Nie sú vybrané žiadne signály. Použite predvoľby alebo expertný režim zobrazenia na výber signálov',
};
